/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserIdentityModel } from '../../models/user-identity-model';

export interface UserIdGet$Params {
  id: string;
}

export function userIdGet(http: HttpClient, rootUrl: string, params: UserIdGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<UserIdentityModel>> {
  const rb = new RequestBuilder(rootUrl, userIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<UserIdentityModel>;
    })
  );
}

userIdGet.PATH = '/User/{id}';
